import { Component, ViewEncapsulation } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

@Component({
    selector: 'app-cd-quiz-result',
    templateUrl: './cd-quiz-result.component.html',
    styleUrls: ['./cd-quiz-result.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export class CdQuizResultPage {
    score: number;
    answers: any;
    correctAnswers: Array<Object> = [];
    wrongAnswers: Array<Object> = [];
    expandedAnswers = new Set<number>();

    constructor(private router: Router) {
        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                const navigation = this.router.getCurrentNavigation();
                if (navigation?.extras?.state) {
                    this.score = navigation.extras.state.score;
                    this.answers = navigation.extras.state.answers;
                    this.answers.forEach((answer: any) => {
                        if (answer.value) {
                            this.correctAnswers.push(answer);
                        } else {
                            answer.true = answer.true.replaceAll('<p>', '');
                            this.wrongAnswers.push(answer);
                        }
                    });
                }
            }
        });
    }

    toggleAnswer(index: number): void {
        if (this.expandedAnswers.has(index)) {
            this.expandedAnswers.delete(index);
        } else {
            this.expandedAnswers.add(index);
        }
    }

    onFinish() {
        this.router.navigate(['/app/practice']);
    }
}
